import { FC } from 'react'
import PerSpacer from '../Spacer'
import PerIcon from '../Icon'
import PerText from '../Text'
import { icons } from '../Icon/icons'
import { Colors } from '../../util/types'
import './index.less'

export interface PerEmptyProps {
  icon?: keyof typeof icons | boolean
  iconColor?: Colors
  iconSize?: 'm' | 'xxl'
  heading?: string
  info?: string
  info2?: string
  preserveLineBreaks?: boolean
  button?: React.ReactNode
}

export const PerEmpty: FC<PerEmptyProps> = ({
  icon,
  iconColor = 'secondary',
  iconSize = 'm',
  heading,
  info,
  info2,
  preserveLineBreaks = false,
  button,
}) => {
  const iconSizeDefault = 50
  const iconSizeFunction = () => {
    if (iconSize === 'm') {
      return iconSizeDefault
    } else if (iconSize === 'xxl') {
      return 150
    } else {
      return iconSizeDefault
    }
  }

  return (
    <PerText my="m" align="center" color="secondary">
      {icon && (
        <PerSpacer mb="s">
          <PerIcon name={icon === true ? 'empty_stroke' : icon} color={iconColor} variant="decoration" size={iconSizeFunction()} />
        </PerSpacer>
      )}
      {heading && (
        <PerText appearance="heading" mb={info ? 'xxs' : undefined}>
          {heading}
        </PerText>
      )}
      {info && (
        <PerText appearance="info" className={preserveLineBreaks ? 'per-empty__info--pre-line' : undefined}>
          {info}
        </PerText>
      )}
      {info2 && (
        <PerText appearance="info" className={preserveLineBreaks ? 'per-empty__info--pre-line' : undefined}>
          {info2}
        </PerText>
      )}
      {button && <PerSpacer mt="s">{button}</PerSpacer>}
    </PerText>
  )
}
